<template>
  <div class="score-debug">
    <div class="score-item" v-for='item, id in $store.state.scoreCache'>
      <h3>{{item.options.label}} ({{id}})</h3>
      <p>Score:{{item.score}}</p>
      <p>Average:{{item.average_score}}</p>
      <p>Hi Score: {{item.high_score}}</p>
      <p>Max score: {{item.max_score}}</p>
      <p>Matching: {{item.options.match.key}}</p>
      <p>Included questions; {{item.options.keys}}</p>
      <p>Band: {{item.banding}}</p>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped lang='scss'>
  .score-debug {
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 10px;
  }
  .score-item {
    margin-bottom: 1rem;
  }
  h3 {
    margin: 0 0 0.3rem 0;
    font-size: 90%;
  }
  p {
    margin: 0;
    font-size: 13px;
  }
</style>